/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    CashRegisterDto,
    InitOtpResponseDto,
    CashRegisterStatusHistoryPage,
} from 'data/api/cashRegister/cashRegistersClient.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { PageQueryParams } from 'data/api/apiCommon.typings';

export enum CashRegisterDetailsActionType {
    OPEN_REGISTRY_CASH_REGISTER_CARD_PAGE = 'CashRegisterCard/ open page',
    EXIT_REGISTRY_CASH_REGISTER_CARD_PAGE = 'CashRegisterCard/ exit page',

    FETCH_CASH_REGISTER_DETAILS_SUCCESS = 'CashRegisterCard/ fetch details success',

    CREATE_INIT_OTP = 'CashRegisterCard/ create init otp',
    CREATE_INIT_OTP_SUCCESS = 'CashRegisterCard/ create init otp success',

    FETCH_CASH_REGISTER_STATUS_HISTORY = 'CashRegisterCard/ fetch status history',
    FETCH_CASH_REGISTER_STATUS_HISTORY_SUCCESS = 'CashRegisterCard/ fetch status history success',

    FETCH_CASH_REGISTER_CARD_DATA_ERROR = 'CashRegisterCard/ fetch cash register card data error',
}

export const openRegistryCashRegisterCardAction = (factoryNumber: string) =>
    createAction(CashRegisterDetailsActionType.OPEN_REGISTRY_CASH_REGISTER_CARD_PAGE, factoryNumber);

export const exitRegistryCashRegisterCardAction = () =>
    createAction(CashRegisterDetailsActionType.EXIT_REGISTRY_CASH_REGISTER_CARD_PAGE);

export const fetchCashRegisterDetailsSuccessAction = (payload: CashRegisterDto) =>
    createAction(CashRegisterDetailsActionType.FETCH_CASH_REGISTER_DETAILS_SUCCESS, payload);

export const createInitOtpAction = () => createAction(CashRegisterDetailsActionType.CREATE_INIT_OTP);

export const createInitOtpSuccessAction = (payload: InitOtpResponseDto) =>
    createAction(CashRegisterDetailsActionType.CREATE_INIT_OTP_SUCCESS, payload);

export const fetchCashRegisterStatusHistoryAction = (params: PageQueryParams) =>
    createAction(CashRegisterDetailsActionType.FETCH_CASH_REGISTER_STATUS_HISTORY, params);

export const fetchCashRegisterStatusHistorySuccessAction = (payload: CashRegisterStatusHistoryPage) =>
    createAction(CashRegisterDetailsActionType.FETCH_CASH_REGISTER_STATUS_HISTORY_SUCCESS, payload);

export const fetchCashRegisterCardDataErrorAction = (notification: Notification) =>
    createAction(CashRegisterDetailsActionType.FETCH_CASH_REGISTER_CARD_DATA_ERROR, { notification });

export type CashRegisterDetailsAction =
    | ReturnType<typeof openRegistryCashRegisterCardAction>
    | ReturnType<typeof exitRegistryCashRegisterCardAction>
    | ReturnType<typeof fetchCashRegisterDetailsSuccessAction>
    | ReturnType<typeof createInitOtpAction>
    | ReturnType<typeof createInitOtpSuccessAction>
    | ReturnType<typeof fetchCashRegisterStatusHistoryAction>
    | ReturnType<typeof fetchCashRegisterStatusHistorySuccessAction>
    | ReturnType<typeof fetchCashRegisterCardDataErrorAction>;
